"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var $dyn;
(function ($dyn) {
    var controls;
    (function (controls) {
        var VerticalTabs = /** @class */ (function (_super) {
            __extends(VerticalTabs, _super);
            function VerticalTabs() {
                return _super !== null && _super.apply(this, arguments) || this;
            }
            VerticalTabs.prototype.init = function (data, element) {
                var _this = this;
                _super.prototype.init.call(this, data, element);
                this.DropListVisual = $dyn.observable(false);
                this.ActiveItemLabel = $dyn.computed(function () {
                    var activeItem = _this.ActiveItem();
                    return activeItem ? $dyn.value(activeItem.Label) : undefined;
                });
                this.headerKeyDown = function (evt) {
                    var stopProp = false;
                    if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.downArrow })) {
                        _this.ChangeTabHeaderFocus(1);
                        stopProp = true;
                    }
                    else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.upArrow })) {
                        _this.ChangeTabHeaderFocus(-1);
                        stopProp = true;
                    }
                    else if ($dyn.util.isShortcutKeyPressed(evt, { keyCode: $dyn.ui.KeyCodes.enter })) {
                        var focusedItem = _this.FocusedItem();
                        if (focusedItem) {
                            focusedItem.Activate();
                        }
                    }
                    else {
                        _this.keyDown(evt);
                    }
                    if (stopProp && evt && evt.stopPropagation) {
                        evt.stopPropagation();
                    }
                };
                this._zoomModeWidthObserver = $dyn.observe($dyn.shell.zoomModeWidth, function (inZoom) {
                    if (inZoom) {
                        _this.DropListVisual(true);
                    }
                    else {
                        _this.DropListVisual(false);
                    }
                });
            };
            VerticalTabs.prototype.dispose = function () {
                if (this._zoomModeWidthObserver) {
                    this._zoomModeWidthObserver.dispose();
                }
                _super.prototype.dispose.call(this);
            };
            /**
             * @returns The active (currently visible) item in the pivot.
             */
            VerticalTabs.prototype.ActiveItem = function () {
                var e_1, _a;
                var activeItem;
                var activeName = this.activeItemName();
                var children = $dyn.value(this.Children);
                try {
                    for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                        var item = children_1_1.value;
                        if (item.Name === activeName) {
                            activeItem = item;
                        }
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (children_1_1 && !children_1_1.done && (_a = children_1.return)) _a.call(children_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
                return activeItem;
            };
            return VerticalTabs;
        }(controls.PivotBase));
        controls.VerticalTabs = VerticalTabs;
        // tslint:disable:object-literal-sort-keys
        var verticalTabShortcuts = {
            NextTab: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.downArrow },
                Handler: function () {
                    return this.NavigateTab(1);
                },
                ShowToUser: function () { return $dyn.value(this.ShowHeaders); },
                Description: $dyn.label("Pivot_NextTab"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
            PreviousTab: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.upArrow },
                Handler: function () {
                    return this.NavigateTab(-1);
                },
                ShowToUser: function () { return $dyn.value(this.ShowHeaders); },
                Description: $dyn.label("Pivot_PrevTab"),
                Category: $dyn.ui.ShortcutCategory.Navigate
            },
        };
        VerticalTabs.prototype.Shortcuts = $dyn.extendPrototype(VerticalTabs.prototype.Shortcuts, verticalTabShortcuts);
    })(controls = $dyn.controls || ($dyn.controls = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=VerticalTabs.js.map
